<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('options.newOption')"></page-title>
    </div>

    <jet-form-section @submitted="createSet()">

        <template #form>

            <form-card :title="$t('options.option')" :description="$t('options.optionDescription')">

                <div class="col-span-6">
                    <label for="name" class="block text-sm font-medium text-gray-700">{{ $t("options.name") }} <RequiredMark /></label>
                    <input type="text" name="name" id="name" v-model="form.name"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                           autofocus />
                    <jet-input-error :message="form.errors.name" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="title" class="block text-sm font-medium text-gray-700">{{ $t("options.title") }} <RequiredMark /></label>
                    <input type="text" name="title" id="title" v-model="form.title"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors.title" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="description"
                           class="block text-sm font-medium text-gray-700">{{ $t("options.description") }} <RequiredMark /></label>

                    <textarea type="text" name="reason" id="description"
                              v-model="form.description"
                              class="focus:ring-minplan-blue focus:border-minplan-blue w-full mt-3"
                              autofocus></textarea>
                    <jet-input-error :message="form.errors.description" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="cost" class="block text-sm font-medium text-gray-700">{{ $t("options.cost") }}</label>
                    <div class="flex">
                        <input type="text" name="cost" id="cost" v-model="form.cost" class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                        <span class="inline-flex items-center px-3 border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm mt-1">CHF</span>
                    </div>
                    <jet-input-error :message="form.errors.cost" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="cost" class="block text-sm font-medium text-gray-700">{{ $t("options.unit") }}</label>
                    <Dropdown v-model="form.unit"
                              :options="units"
                              optionLabel="name"
                              optionValue="value"
                              :showClear="false"
                              class="w-full mt-1 min-w-0 sm:text-sm">
                    </Dropdown>
                </div>

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import { units } from "@/Pages/Advisor/Option/values";
import RequiredMark from "@/Shared/Components/RequiredMark";

export default defineComponent({
    props: ["set"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        FormCard,
        RequiredMark
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        createSet() {
            this.form.post(this.route("advisors.option.store", this.set.uuid), {
                preserveScroll: true,
                preserveState: false,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "options.created"
                })
            });
        }
    },
    setup() {

        const form = useForm({
            name: null,
            title: null,
            description: null,
            cost: null,
            unit: null
        });

        return { form, units };
    }
});
</script>

<style scoped></style>
